import React, { useContext, useState } from 'react'
import { PanelDeControlContext } from '../../../context/PanelDeControlContext';
import apiAsistentes from '../../../services/apis/apiAsistentes';
import style from './style.module.css'

const SubirListaDeAsistentes = ({ onSuccess }) => {

    const { eventoSeleccionado } = useContext( PanelDeControlContext );
    const [ selectedFile, setSelectedFile ] = useState();
    const [ mensajeError, setMensajeError ] = useState();

    const types = [
        'text/csv',
        'text/plain',
        'application/csv',
        'text/comma-separated-values',
        'application/excel',
        'application/vnd.ms-excel',
        'application/vnd.msexcel',
        'text/anytext',
        'application/octet-stream',
        'application/txt',
    ];

    const necessaryHeaders = [
        'nombre',
        'correo'
    ];

    const changeHandler = (e) => {
        const file = e.target.files[0] || null;
        if ( !types.includes(file.type) ) { return setMensajeError('Selecciona un archivo válido, por el momento solo aceptamos archivos CSV') }
        setSelectedFile(file)
    }

    const submitFile = () => {

        if( !selectedFile ) { return setMensajeError('Selecciona un archivo válido, por el momento solo aceptamos archivos CSV') }

        const reader = new FileReader();

        reader.onload = async() => {
            const arr = reader.result.split('\n')
            const headers = arr[0].split(',')
            const datos = arr.splice(1);

            // El documento incluye los headers solicitados y ver su posición
            const includesAllNecesaryHeaders = necessaryHeaders.every(i =>  headers.includes(i));
            if ( !includesAllNecesaryHeaders ) { return }

            const headersPosition = {
                'nombre': headers.indexOf('nombre'),
                'correo': headers.indexOf('correo'),
            }

            const listaDeAsistentes = datos.map((elemento) => {
                const asistente = elemento.split(',');
                
                return {
                    nombre: asistente[headersPosition['nombre']],
                    correo: asistente[headersPosition['correo']]
                }

            })

            const response = await apiAsistentes.post({
                evento: eventoSeleccionado._id,
                lista: listaDeAsistentes
            });

            if( response.error) { return setMensajeError(response.response.errorMsg) }

            onSuccess(response.response.data)

        }
        
        reader.readAsText(selectedFile)
    }

    return (<>
        
        <div className="row">
            <div className="col-auto">
                <input
                    onChange={ changeHandler }
                    type="file" name="file" id=""  className='form-control'/>
            </div>
            <div className="col-auto">
                <button
                    onClick={ submitFile }
                    className={ `btn btn-primary ${ style.botonAgregarAsistentes }` }>
                    Subir lista de asistentes
                </button>
            </div>
        </div>

        {mensajeError &&
            <div className="container-fluid p-2 mt-3 bg-warning">
                <p>{ mensajeError }</p>
            </div>
        }

    </>)
}

export default SubirListaDeAsistentes
